import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { NavigationMenuList } from '@radix-ui/react-navigation-menu';
export const MenuList = /*#__PURE__*/_styled(NavigationMenuList, process.env.NODE_ENV === "production" ? {
  target: "ecqio6a0"
} : {
  target: "ecqio6a0",
  label: "MenuList"
})(process.env.NODE_ENV === "production" ? {
  name: "pv1s1f",
  styles: "margin:0;padding:0;list-style:none"
} : {
  name: "pv1s1f",
  styles: "margin:0;padding:0;list-style:none/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnVMaXN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVtRCIsImZpbGUiOiJNZW51TGlzdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IE5hdmlnYXRpb25NZW51TGlzdCB9IGZyb20gJ0ByYWRpeC11aS9yZWFjdC1uYXZpZ2F0aW9uLW1lbnUnO1xuZXhwb3J0IGNvbnN0IE1lbnVMaXN0ID0gc3R5bGVkKE5hdmlnYXRpb25NZW51TGlzdCkgYFxuICBtYXJnaW46IDA7XG4gIHBhZGRpbmc6IDA7XG4gIGxpc3Qtc3R5bGU6IG5vbmU7XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9TWVudUxpc3QuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});